import { IFileDownloadState } from "./file-downolad.interface";

export function createFileDownloadState(): IFileDownloadState {
  return {
    errors: null,
    fetching: false,
  };
}
